import React from "react";
import NodePorts from "./NodePorts";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography } from "@material-ui/core";
import { Keyboard } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  nodeContainer: {
    minWidth: 200,
    maxWidth: 280,
    padding: theme.spacing(1.5, 2),
    borderRadius: 8,
    background: "#374151",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    color: "white",
    position: "relative",
    transition: "opacity 0.2s ease",
    "&:hover": {
      opacity: 0.9,
    },
  },
  nodeHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  nodeIcon: {
    fontSize: 20,
  },
  nodeLabel: {
    fontWeight: 600,
    fontSize: 14,
    color: "white",
  },
  nodeContent: {
    fontSize: 12,
    opacity: 0.95,
    marginTop: theme.spacing(0.5),
    padding: theme.spacing(0.75),
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    borderRadius: 4,
  },
  handle: {
    width: 12,
    height: 12,
    background: "white",
    border: "2px solid #374151",
    borderRadius: "50%",
  },
}));

const TypingNode = ({ data, selected }) => {
  const classes = useStyles();
  const ms = Number(data?.ms) || (Number(data?.seconds) ? Number(data.seconds) * 1000 : 1200);
  const label = ms >= 1000 ? `Typing ${Math.round(ms / 1000)}s` : `Typing ${ms}ms`;

  return (
    <Box
      className={classes.nodeContainer}
      style={{
        border: selected ? "2px solid rgba(255, 255, 255, 0.5)" : "1px solid rgba(255, 255, 255, 0.2)",
      }}
    >
      <NodePorts color="#374151" />
      <Box className={classes.nodeHeader}>
        <Keyboard className={classes.nodeIcon} />
        <Typography className={classes.nodeLabel}>Typing</Typography>
      </Box>
      <Box className={classes.nodeContent}>{label}</Box>
    </Box>
  );
};

export default TypingNode;

